var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartyPopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "party-popper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.7 17.45L3 33.5L19.05 27.815M6 5H6.015M33 12.5H33.015M22.5 3.5H22.515M33 30.5H33.015M33 3.5L29.64 4.625C28.6836 4.94358 27.8675 5.58446 27.3312 6.43809C26.795 7.29171 26.5719 8.30509 26.7 9.305C26.85 10.595 25.845 11.75 24.525 11.75H23.955C22.665 11.75 21.555 12.65 21.315 13.91L21 15.5M33 20L31.77 19.505C30.48 18.995 29.04 19.805 28.8 21.17C28.635 22.22 27.72 23 26.655 23H25.5M16.5 3.5L16.995 4.73C17.505 6.02 16.695 7.46 15.33 7.7C14.28 7.85 13.5 8.78 13.5 9.845V11M16.5 20C19.395 22.895 20.745 26.255 19.5 27.5C18.255 28.745 14.895 27.395 12 24.5C9.105 21.605 7.755 18.245 9 17C10.245 15.755 13.605 17.105 16.5 20Z",
    stroke: "#04D538",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyPopper);
export default __webpack_public_path__ + "static/media/party-popper.80c71bda27e3bd01eb36cbec0c077709.svg";
export { ForwardRef as ReactComponent };